<template>
  <div class="tag-level-setting">
    <el-slider v-model="sliderRange" :marks="sliderMarks" range />
  </div>
</template>

<script setup>
  import { ref, watchEffect, defineExpose, defineEmits, getCurrentInstance, defineProps, onMounted } from 'vue'
  import { batchUpdateViolationConfig } from '@/api/jbh'

  const { proxy } = getCurrentInstance()

  const props = defineProps({
    options: {
      type: Array,
      default: () => [],
    },
  })

  const emit = defineEmits(['success'])

  const sliderRange = ref([30, 60])

  const blackWidth = ref('')
  const sliderMarks = ref({})

  watchEffect(() => {
    const marks = { 0: '0', 100: '100(白)' }
    sliderRange.value.forEach((item, index) => {
      marks[item] = `${item}(${index === 0 ? '黑' : '灰'})`
      if (index === 0) blackWidth.value = item + '%'
    })
    sliderMarks.value = marks
  })

  function submit() {
    const [minScore, maxScore] = sliderRange.value
    if (minScore === 0 || maxScore === 100 || minScore === maxScore)
      return proxy.$baseMessage('分数设置不正确', 'warning', 'vab-hey-message-warning')
    const params = ['BLACK', 'GRAY', 'WHITE'].map((t) => {
      const { id, type } = props.options.find((e) => e.type === t)
      const item = { id, type }
      if (t === 'BLACK') {
        item.minScore = 0
        item.maxScore = minScore
      } else if (t === 'GRAY') {
        item.minScore = minScore + 1
        item.maxScore = maxScore
      } else {
        item.minScore = maxScore + 1
        item.maxScore = 100
      }
      return item
    })
    console.log('params', params)
    batchUpdateViolationConfig({ params }).then(() => {
      proxy.$baseMessage(`处理成功！`, 'success', 'vab-hey-message-success')
      emit('success')
    })
  }

  onMounted(() => {
    sliderRange.value = ['BLACK', 'GRAY'].map((t) => {
      const { maxScore } = props.options.find((e) => e.type === t)
      return +maxScore
    })
  })

  defineExpose({
    submit,
  })
</script>

<style lang="scss" scoped>
  .tag-level-setting {
    margin-bottom: 30px;

    :deep(.el-slider__stop) {
      background: #333;
      margin-top: -1px;
    }

    :deep(.el-slider__runway)::before {
      content: '';
      position: absolute;
      height: 6px;
      width: v-bind(blackWidth);
      background-color: black;
      left: 0;
      top: -1px;
      border-radius: 3px;
    }

    :deep(.el-slider__bar) {
      background-color: gray;
    }

    :deep(.el-slider__bar) ~ .el-slider__button-wrapper > .el-slider__button {
      border-color: gray;
    }

    :deep(.el-slider__bar) + .el-slider__button-wrapper > .el-slider__button {
      border-color: black;
    }

    :deep(.el-slider__marks-text):last-child {
      white-space: nowrap;
      margin-left: -20px;
    }
  }
</style>
